import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { resetBO, updatepassBO } from './resetpassword.model';
import { ErrorService } from 'src/app/error.service';

@Injectable()
export class resetpasswordHTTPService {
    constructor(private http: HttpClient, public errorService: ErrorService) { }

    resendPassword(saveList: resetBO): Observable<any> {
        let url = "api/Login/ForgetPassword?";
        return this.http.post<any>(url, saveList, { observe: 'response' }).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        )
    }

    resetPassword(saveList: updatepassBO): Observable<any> {
        let url = "api/Login/ChangePassword?";
        return this.http.post<any>(url, saveList, { observe: 'response' }).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        )
    }

}